import { useCallback, useEffect, useState } from 'react';
import { getIndexedDBKey } from 'modules/get-indexedDB-key/get-indexedDB-key';

export function useIndexedDB(databaseName, objectStoreName) {
  const [database, setDatabase] = useState({});

  const initDatabase = useCallback(() => {
    const request = indexedDB.open(databaseName);

    request.onupgradeneeded = (event) => {
      const database = event.target.result;
      setDatabase(database);
      database.createObjectStore(objectStoreName, { keyPath: 'key' });
      console.warn(
        'IndexedDB Upgrade Needed. Created fresh Database and ObjectStore',
      );
    };

    request.onsuccess = (event) => {
      const database = event.target.result;
      setDatabase(database);
    };

    request.onerror = (event) => {
      console.error('indexedDB error', event);
    };
  }, [databaseName, objectStoreName]);

  const getTransaction = useCallback(
    (objectStoreName) => {
      const transaction = database.transaction(objectStoreName, 'readwrite');
      transaction.onerror = (event) => {
        console.error('indexedDB transaction', event.target.error);
      };

      return transaction;
    },
    [database],
  );

  const getObjectStore = useCallback(() => {
    const transaction = getTransaction(objectStoreName);
    return transaction.objectStore(objectStoreName);
  }, [getTransaction, objectStoreName]);

  const createValue = useCallback(
    (value) => {
      const configuration = getObjectStore();
      configuration.add(value);
    },
    [getObjectStore],
  );

  const updateValue = useCallback(
    (value) => {
      const configuration = getObjectStore();
      configuration.put(value);
    },
    [getObjectStore],
  );

  const deleteKey = useCallback(
    (key) => {
      const configuration = getObjectStore();
      configuration.delete(key);
    },
    [getObjectStore],
  );

  const readKey = useCallback(
    (key) => {
      return getIndexedDBKey(key, databaseName, objectStoreName);
    },
    [databaseName, objectStoreName],
  );

  useEffect(() => {
    initDatabase();
  }, [initDatabase]);

  return { createValue, updateValue, deleteKey, readKey };
}
